// tslint:disable:max-line-length

import React from 'react';

export const ArrowCaretLeft = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M5.3568 7.152C4.73013 7.54367 4.73013 8.45633 5.3568 8.848L10.47 12.0438C11.136 12.46 12 11.9812 12 11.1958L12 4.80425C12 4.01881 11.136 3.53997 10.47 3.95625L5.3568 7.152Z" />
    </svg>
  );
};
